// extracted by mini-css-extract-plugin
export var postCardClass = "PostItemCard-module--postCardClass--+cqA2";
export var mainImageClass = "PostItemCard-module--mainImageClass--5RoUI";
export var titleLinkClass = "PostItemCard-module--titleLinkClass--keohQ";